import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { activeVersionForDate } from '../components/templateTimeline/helpers'
import type { TemplateVersionInfo } from '../types/templateModel'
import { useTemplateVersionInfos } from '../uiModels/versionInfo/useTemplateVersionInfo'
import { useConfigurationContext } from './configurationContext'

export const usePreviousTemplateVersionInfo = (
  forVersion: Optional<TemplateVersionInfo>,
) => {
  const { viewAt } = useConfigurationContext()
  const allTemplateVersionsForId = useTemplateVersionInfos(
    forVersion?.identifier,
  )

  return useMemo(
    () =>
      activeVersionForDate(
        allTemplateVersionsForId.filter(
          (version) =>
            version !== forVersion && version.fromDate != forVersion?.fromDate, // Discard any versions for that same date.
        ),
        viewAt,
      ),
    [allTemplateVersionsForId, forVersion, viewAt],
  )
}
